import { DashboardNotification } from '@lili/lili-frontend-common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { navigateToRelevantAddMoney, VIEWS_MAP } from '../../../../router/constants';
import { trackMixPanel } from '../../../../services/mixpanel.service';

export enum DashboardNotificationType {
  AddMoney,
  UploadEIN,
  ActivateCard,
}

interface DashboardNotificationItem {
  type: DashboardNotificationType;
  title: string;
  actionTitle: string;
  cta: () => void;
  reverseContentOrder?: boolean;
}

const notificationItemForType = (type: DashboardNotificationType): DashboardNotificationItem | null => {
  const { t } = useTranslation();
  const { t: dashboardT } = useTranslation('dashboardFaceliftResourcesEN');
  const navigate = useNavigate();

  switch (type) {
    case DashboardNotificationType.AddMoney:
      return {
        type: DashboardNotificationType.AddMoney,
        title: t('ADD_MONEY_NOTIFICATION_TITLE'),
        actionTitle: t('ADD_MONEY_NOTIFICATION_LINK_TEXT'),
        cta: () => {
          trackMixPanel('act on fund your account banner');
          navigateToRelevantAddMoney(navigate);
        },
        reverseContentOrder: true,
      };
    case DashboardNotificationType.ActivateCard:
      return {
        type: DashboardNotificationType.ActivateCard,
        title: dashboardT('CARD_TRACKER_NOTIFICATION_TITLE'),
        actionTitle: dashboardT('CARD_TRACKER_NOTIFICATION_LINK_TEXT'),
        cta: () => navigate(`/${VIEWS_MAP.ACTIVATE_CARD}`),
      };
    case DashboardNotificationType.UploadEIN:
      return {
        type: DashboardNotificationType.UploadEIN,
        title: t('UPLOAD_EIN_DOC.NOTIFICATION.TITLE'),
        actionTitle: t('UPLOAD_EIN_DOC.NOTIFICATION.CTA'),
        cta: () => {},
      };
    default:
      return null;
  }
};

export interface DashboardNotificationManagerProps {
  notifications: DashboardNotificationType[];
  onClose: (type: DashboardNotificationType) => void;
  onClick: (type: DashboardNotificationType) => void;
}

export const DashboardNotificationManager = ({
  notifications,
  onClose,
  onClick,
}: DashboardNotificationManagerProps) => {
  const sortedNotifications = notifications.sort((a, b) => a - b);
  const notificationItemToShow = notificationItemForType(sortedNotifications[0]);

  if (!notificationItemToShow) {
    return <div />;
  }

  return (
    <DashboardNotification
      className='absolute top-0 left-0'
      onClose={() => onClose(notificationItemToShow.type)}
      onActionClick={() => {
        notificationItemToShow.cta();
        onClick(notificationItemToShow.type);
      }}
      title={notificationItemToShow.title}
      actionTitle={notificationItemToShow.actionTitle}
      reverseContentOrder={notificationItemToShow.reverseContentOrder || false}
    />
  );
};
